document.addEventListener("octane.quiz.completed", function(event) {

  console.log("octane.quiz.completed event", event.detail.answers);
  const answers = event.detail.answers;

  // Create the redirect URL base
  let newurl = "https://236121-d5.myshopify.com/pages/chapters-normal-skin?";
  
  // Map of answer keys to query parameter names
  const paramNamesMap = {
    'skin_sebum_type': 'skin_type',
    'patient_lifestyle': 'lifestyle',
    'patient_pigmentation': 'pigmentation',
    'medical_skin_conditions': 'skin_conditions',
    'sun_exposure_history': 'sun_exposure',
    'sunscreen_habits': 'sunscreen'
  };
  
  // Build the parameters object
  const paramsObj = {};
  
  // Process each parameter
  for (const [answerKey, paramName] of Object.entries(paramNamesMap)) {
    let value = answers[answerKey];
    if (typeof value === 'string') {
      // Remove spaces after commas
      value = value.replace(/, /g, ',');
    }
    paramsObj[paramName] = value;
  }
  
  // Use URLSearchParams to build the query string
  const params = new URLSearchParams(paramsObj);
  
  // Convert to string and replace '%2C' with ','
  const queryString = params.toString().replace(/%2C/g, ',');
  
  // Construct the final URL
  newurl = `${newurl}${queryString}`;
  console.log(newurl)
  
  window.location.replace(newurl);

}, false);

